var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.069,
    height: 15.069,
    viewBox: "0 0 15.069 15.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_Yellow",
    "data-name": "Search Yellow",
    transform: "translate(-780.833 -319.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(780.833 319.917)",
    fill: "none",
    stroke: "#fffb00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.047,
    cy: 6.047,
    r: 6.047,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.047,
    cy: 6.047,
    r: 5.047,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 4.535,
    y2: 4.535,
    transform: "translate(790.659 329.743)",
    fill: "none",
    stroke: "#fffb00",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchYellow);
export default __webpack_public_path__ + "static/media/search-yellow.f736f08166cc3d3cebd63563a0a2303a.svg";
export { ForwardRef as ReactComponent };